import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@env/environment';

import { ClusterModel } from '@app/core/models';
import { IClusterApiModel } from '@app/core/models/api';

@Injectable()
export class ClusterApiService {
  constructor(private http: HttpClient) {}

  getCluster(slug: string): Observable<ClusterModel> {
    const params = new HttpParams().append('slug', slug);

    return this.http
      .get<IClusterApiModel>(`${environment.API_URL}v5/cluster.json`, {
        params,
      })
      .pipe(map(res => new ClusterModel(res)));
  }

  getClusters(): Observable<Array<ClusterModel>> {
    return this.http
      .get<Array<IClusterApiModel>>(`${environment.API_URL}v5/clusters.json`)
      .pipe(map(res => res.map(item => new ClusterModel(item))));
  }

  getClusterInfo(
    id: number | string,
    isParent: boolean = true,
  ): Observable<ClusterModel> {
    if (!id) {
      console.log('No cluster !!!!');
      return null;
    }
    const params = new HttpParams().append('cluster', `${id}`);

    return this.http
      .get<Array<IClusterApiModel>>(`${environment.API_URL}v5/clusters.json`, {
        params,
      })

      .pipe(
        map(res => res.map(item => new ClusterModel(item))),
        map(([data]) => {
          if (isParent || data.id === +id) {
            return data;
          }

          const findChild = (
            list: Array<ClusterModel>,
          ): ClusterModel | null => {
            if (Array.isArray(list) === false || list.length === 0) {
              return null;
            }

            let found = list.find(el => el.id === +id);

            if (found != null) {
              return found;
            }

            for (const item of list) {
              found = findChild(item.children);
              if (found != null) {
                return found;
              }
            }

            return null;
          };

          return findChild(data.children);
        }),
      );
  }
}
